import startOfDay from 'date-fns/startOfDay'
import { IAvailableDaysFactory } from '../../entities/available-days/AvailableDays'
import { parseDate } from '../../utils/parse-date'

export type IAvailableDaysResponse = Record<string, number>

export const transformAvailableDays = (date: IAvailableDaysResponse) : IAvailableDaysFactory => {
  const days = new Map<string, number>()
  Object.entries(date).forEach(([date, count]) => days.set(startOfDay(parseDate(date)).toString(), count))

  return {
    days,
  }
}
